// Горизонтальная полоса стадий воронки — как в карточке Bitrix.
//
// Сегменты-стрелки: пройденные закрашены мягко, текущая — акцентом. Терминальные
// стадии («выиграна»/«проиграна» и прочие с семантикой S/F) стоят справа ОТДЕЛЬНОЙ
// группой капсул: они не «следующий шаг» пути, а два разных его конца, и в один ряд
// со стрелками читались бы как этап после этапа.
//
// Названия и порядок стадий компонент НЕ знает: их приносит страница из справочника
// ядра (refs.stageOptions + refs.stageKind). Клик по стадии отдаётся наружу как есть —
// проводку в API (и право на неё) делает страница. Без onStageClick полоса рисуется
// НЕ кнопками, а спанами: кнопка, ведущая в никуда, — это обещание, которого
// компонент выполнить не может.
import './card.css'

/** Стадия из справочника: kind — семантика ядра (won/lose/work), не цвет. */
export interface Stage {
  id: string
  name: string
  kind: 'won' | 'lose' | 'work'
}

interface Props {
  stages: Stage[]
  /** STAGE_ID текущей стадии (полный код, как в справочнике). */
  current: string
  /** Нет обработчика — полоса только показывает (нет права записи). */
  onStageClick?: (stage: Stage) => void
  /** Смена стадии уже отправлена — клики выключены, чтобы не слать вторую. */
  busy?: boolean
}

export function StageBar({ stages, current, onStageClick, busy }: Props) {
  // Справочник не пришёл — полосу не рисуем: показывать пустую рамку было бы
  // утверждением «стадий нет», а их просто не у кого спросить.
  if (stages.length === 0) return null

  const рабочие = stages.filter((s) => s.kind === 'work')
  const терминальные = stages.filter((s) => s.kind !== 'work')
  const текущая = stages.find((s) => s.id === current)
  // Терминальная текущая (выиграна/проиграна) — путь пройден целиком.
  const весьПуть = !!текущая && текущая.kind !== 'work'
  const номерТекущей = рабочие.findIndex((s) => s.id === current)

  const сегмент = (s: Stage, класс: string) => {
    const активна = s.id === current
    if (!onStageClick) {
      return (
        <span key={s.id} className={`stage-seg${класс}`} title={s.name}>{s.name}</span>
      )
    }
    return (
      <button
        key={s.id}
        type="button"
        className={`stage-seg${класс}`}
        aria-pressed={активна}
        title={s.name}
        disabled={busy}
        onClick={() => onStageClick(s)}
      >
        {s.name}
      </button>
    )
  }

  return (
    <div className="stagebar">
      <div className="stagebar-steps">
        {рабочие.map((s, i) => {
          const пройдена = весьПуть || (номерТекущей >= 0 && i < номерТекущей)
          const текущаяЛи = i === номерТекущей
          return сегмент(s, `${пройдена ? ' done' : ''}${текущаяЛи ? ' now' : ''}`)
        })}
      </div>
      {терминальные.length > 0 && (
        <div className="stage-final">
          {терминальные.map((s) =>
            сегмент(s, ` ${s.kind}${s.id === current ? ' now' : ''}`))}
        </div>
      )}
    </div>
  )
}
